/**
* Hreflang helpers for the /notary/* cluster. Thai canonical is x-default;
 * Locale mirrors are advertised only when a physical route exists.
*/
import { NOTARY_COMPARE_SLUG_MAP } from "./compare-locale";

const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const NOTARY_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/notary` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/notary` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/notary` },
];

export function notaryServiceHreflangLinks(slug: string) {
  const svc = `/notary/services/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${svc}` },
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${svc}` },
  ];
}

export function notaryCityHreflangLinks(slug: string) {
  const p = `/notary/city/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p}` },
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p}` },
  ];
}

/**
* Reciprocal cluster for the Notary FAQ hub: Thai canonical at
* /notary/questions plus the 6 shipped locale mirrors.
*/
export const NOTARY_QUESTIONS_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/notary/questions` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/notary/questions` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/notary/questions` },
];

/**
* Locales that ship a physical /notary/compare mirror. Never advertise a
* locale in hreflang that would 404 — Google treats that as a broken cluster.
*/
const COMPARE_LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

/** Reciprocal hreflang cluster for the compare hub (Thai = x-default). */
export function notaryCompareHubHreflangLinks() {
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}/notary/compare` },
    ...COMPARE_LOCALES.map((l) => ({
      rel: "alternate" as const,
      hrefLang: l,
      href: `${BASE}/${l}/notary/compare`,
    })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}/notary/compare` },
  ];
}

/**
* Reciprocal cluster for one compare leaf. Thai slugs are Thai-script while
* the locale mirrors use ASCII slugs, so pass either and we resolve the pair.
*/
export function notaryCompareHreflangLinks(slug: string) {
  const map = NOTARY_COMPARE_SLUG_MAP;
  const thSlug = map[slug] ? slug : (Object.keys(map).find((k) => map[k] === slug) ?? slug);
  const localeSlug = map[thSlug] ?? slug;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}/notary/compare/${encodeURI(thSlug)}` },
    ...COMPARE_LOCALES.map((l) => ({
      rel: "alternate" as const,
      hrefLang: l,
      href: `${BASE}/${l}/notary/compare/${localeSlug}`,
    })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}/notary/compare/${encodeURI(thSlug)}` },
  ];
}

